<!-- UserInfo (custom block type) -->
<script lang="ts">
	import type { CustomBlockComponentProps } from '@portabletext/svelte';
	import SoundCloud from '@samsveltecomponents/core/SoundCloud.svelte';

	interface Props {
		// Property custom blocks receive from @portabletext/svelte when redered
		portableText: CustomBlockComponentProps<{
			url: string;
			height?: number;
			title?: string;
		}>;
	}

	let { portableText }: Props = $props();

	const { url, height, title } = portableText.value;
</script>

<SoundCloud {url} {height} {title} />
